import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import { getDefaultLabels } from './model'

import styles from './Slider.module.scss'

const Label = ({ ariaLabel, children }) => (
  <span aria-label={ariaLabel} className={styles.label} role="presentation">
    {children}
  </span>
)

export const Slider = React.forwardRef(
  (
    {
      fieldClassName,
      id,
      max = 1,
      min = 0,
      labels = getDefaultLabels(),
      name,
      step = 0.01,
      value,
      onBlur,
      onChange,
      isDisabled = false,
    },
    ref,
  ) => {
    const [minLabel, maxLabel] = labels

    return (
      <div className={styles.container}>
        <Label ariaLabel={minLabel}>{minLabel}</Label>
        <input
          className={cx(styles.slider, {
            [fieldClassName]: Boolean(fieldClassName),
          })}
          type="range"
          disabled={isDisabled}
          {...{ id, max, min, name, ref, step, value, onBlur, onChange }}
        />
        <Label ariaLabel={maxLabel}>{maxLabel}</Label>
      </div>
    )
  },
)

export const ControlledSlider = ({
  control,
  fieldClassName,
  id,
  labels,
  max,
  min,
  name,
  step,
  isDisabled,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Slider
        {...{
          id,
          fieldClassName,
          labels,
          max,
          min,
          name,
          step,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
        }}
      />
    )}
    {...{ control, name }}
  />
)
